import {
  BLOOD_GLUCOSE,
  BLOOD_PRESSURE,
  BODY_FAT_PERCENTAGE,
  BODY_HEIGHT,
  BODY_MASS_INDEX,
  BODY_TEMPERATURE,
  BODY_WEIGHT,
  CHEST_CM,
  DISTANCE,
  ENERGY_BURNED,
  HEART_RATE,
  HIPS_CM,
  HR_VARIABILITY,
  MUSCLE_MASS,
  OXYGEN_SATURATION,
  PAIN,
  RESPIRATION,
  RESTING_HEART_RATE,
  SLEEP_DURATION,
  SLEEP_SCORE,
  STEPS, // STRESS_INDEX,
  THIGH_CM,
  WAIST_CM,
  WAIST_HEIGHT_RATIO,
  WAIST_HIP_RATIO,
} from '@constants/fhir';

import { ShareType } from 'generated/types';

export const SHARED_RESOURCE_OBSERVATION_MAP: Record<string, ShareType> = {
  [BLOOD_PRESSURE]: ShareType.VitalSigns_bloodPressure,
  [OXYGEN_SATURATION]: ShareType.VitalSigns_oxygenSaturation,
  [PAIN]: ShareType.VitalSigns_pain,
  [HEART_RATE]: ShareType.VitalSigns_pulse,
  [RESPIRATION]: ShareType.VitalSigns_respiration,
  [BODY_TEMPERATURE]: ShareType.VitalSigns_temperature,
  [HR_VARIABILITY]: ShareType.VitalSigns_hrv,
  // [STRESS_INDEX]: ShareType.VitalSigns_stressIndex,
  [BLOOD_GLUCOSE]: ShareType.Body_bloodSugar,
  [BODY_HEIGHT]: ShareType.Body_bodyHeight,
  [BODY_WEIGHT]: ShareType.Body_bodyWeight,
  [BODY_MASS_INDEX]: ShareType.Body_bodyMassIndex,
  [MUSCLE_MASS]: ShareType.Body_muscleMass,
  [DISTANCE]: ShareType.DailyStats_distance,
  [STEPS]: ShareType.DailyStats_steps,
  [RESTING_HEART_RATE]: ShareType.DailyStats_restingHeartRate,
  [ENERGY_BURNED]: ShareType.DailyStats_energyBurned,
  [SLEEP_DURATION]: ShareType.Sleep_sleepDuration,
  [SLEEP_SCORE]: ShareType.Sleep_sleepScore,
  [BODY_FAT_PERCENTAGE]: ShareType.Body_bodyFatPercentage,
  [CHEST_CM]: ShareType.Body_bodyChestCm,
  [WAIST_CM]: ShareType.Body_bodyWaistCm,
  [HIPS_CM]: ShareType.Body_bodyHipsCm,
  [THIGH_CM]: ShareType.Body_bodyThighCm,
  [WAIST_HEIGHT_RATIO]: ShareType.Body_bodyWaistHeight,
  [WAIST_HIP_RATIO]: ShareType.Body_bodyWaistHip,
};
